// extracted by mini-css-extract-plugin
module.exports = {"title":"logo_title__pywCY","header":"logo_header__JhK6L"};